import { PropsWithChildren, ReactNode } from "react";

interface Props extends PropsWithChildren {
  index: number,
  title?: string;
  rightInfo?: ReactNode;
  collapsed?: boolean;
}

export const ProductGroupAccordion = ({ index, title, rightInfo, collapsed, children }: Props) => {
  return (
  <div className={"flex flex-col gap-4"}>
    <div className={"flex justify-between items-center py-4 border-b-primary-bg border-b-[1px]"}>
      <div className={"flex gap-3 items-center"}>
        <div className={"font-h3 text-2xl w-7 h-7 bg-primary-bg text-white rounded-full flex items-baseline justify-center"}>
          {index}
        </div>
        {title && <p className={"text-sm"}>{title}</p>}
      </div>
  
      {rightInfo && <div className={"flex gap-3"}>
        {rightInfo}
      </div>}
    </div>

    <div className={collapsed ? "hidden" : "block"}>
      {children}
    </div>
  </div>
  )
}